import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import SynonymsComponent from 'components/desktop/Accessory/Components/Synonyms/Synonyms';
import AccessoryLanguageInput from 'components/desktop/Accessory/LanguageInput/AccessoryLanguageInput';
import LanguageSwitch from 'components/desktop/_general/LanguageSwitch/LanguageSwitch';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import useCultureCode from 'hooks/redux/useCultureCode';

export const AccessoryNameInputs = ({ state, handlers }: AccessoryTabProps): JSX.Element => {
	const cultureCode: string = useCultureCode();
	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);
	{
		return (
			<LanguageSwitch
				handleSelectLanguage={(_e: any, selectedLanguage: string) => {
					handlers.setSelectedCultureCode(selectedLanguage);
				}}
				selectedLanguage={state.selectedCultureCode}
				translatable={true}
				onTranslateClick={async () => {
					await handlers.translateAllNames({
						fromCultureCode: cultureCode,
					});
				}}
				entryLanguage={cultureCode}
				content={
					<>
						<AccessoryLanguageInput
							handleNamePluralChange={(input) =>
								handlers.setName({
									cultureCode: state.selectedCultureCode,
									value: input,
									key: 'namePlural',
								})
							}
							handleNameSingularChange={(input) =>
								handlers.setName({
									cultureCode: state.selectedCultureCode,
									value: input,
									key: 'nameSingular',
								})
							}
							namePlural={state.namePlural[state.selectedCultureCode] ?? ''}
							nameSingular={state.nameSingular[state.selectedCultureCode] ?? ''}
							onTranslateNamePluralClick={() =>
								handlers.translateSingleName({
									fromCultureCode: cultureCode,
									text: state.namePlural[cultureCode],
									key: 'namePlural',
								})
							}
							onTranslateNameSingularClick={() =>
								handlers.translateSingleName({
									fromCultureCode: cultureCode,
									text: state.nameSingular[cultureCode],
									key: 'nameSingular',
								})
							}
							selectedLanguage={state.selectedCultureCode}
						/>
						<SynonymsComponent
							cultureCode={state.selectedCultureCode}
							disabled={!isAccessoryEditor}
							handleAddSynonym={handlers.addSynonym}
							handleChangeSynonym={handlers.changeSynonym}
							handleDeleteSynonym={handlers.deleteSynonym}
							synonyms={state.synonyms}
						/>
					</>
				}
			/>
		);
	}
};
